import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "chapter-diagram-editor-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_diagram_editor = _resolveComponent("diagram-editor");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_diagram_editor, {
    id: _ctx.chapterId,
    "diagram-data": _ctx.diagramData,
    "vision-enabled": _ctx.visionEnabled,
    "open-edit-mode": !_ctx.diagramData?.d2Code?.trim(),
    processing: _ctx.isProcessing,
    saved: _ctx.diagramSaved,
    onSave: _ctx.saveDiagramData,
    onRestart: _ctx.restart
  }, null, 8, ["id", "diagram-data", "vision-enabled", "open-edit-mode", "processing", "saved", "onSave", "onRestart"])]);
}